import React, { useEffect } from 'react'
import project_logo from '../img/ROWHWG_logo.png'
import '../css/main.css'
import { useNavigate } from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import { ccaa_actions } from '../store/ccaa_slice';
import {test_monarch} from './MonarchCCAA'
import MonarchCCAA from './MonarchCCAA';
import axios from 'axios';


import {
  Modal,
}  from 'antd';

import {
  Spinner
} from '@chakra-ui/react';


function Nav() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [reRenderPage, setReRenderPage] = React.useState(0);
  const logout_store = useSelector(state => state.ccaa.logout_action);

  //redux store values
  const annual_reporting_summary_store = useSelector(state => state.ccaa.annual_reporting_summary_store);
  const annual_net_conservation_store = useSelector(state => state.ccaa.annual_net_conservation_store);
  const summary_of_effectiveness_store = useSelector(state => state.ccaa.summary_effectiveness_store);
  const upcoming_year_forecast_store = useSelector(state => state.ccaa.upcoming_year_forecast_store);
  const organization_name = useSelector(state => state.ccaa.organization_name_store);
  const auth_user = useSelector(state => state.auth.admin_user);

  ////console.log('auth_user nav init', auth_user)

  //modal functions
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [confirmLoading, setConfirmLoading] = React.useState(false);
  const [confirmLoading2, setConfirmLoading2] = React.useState(false);
  const [modalText, setModalText] = React.useState('Please Save your responses before logging out.');
  const [modalText2, setModalText2] = React.useState('Submitting Values to ROWHWG');
  const [logout_status, setLogout_status] = React.useState(false);
  const [application_status, setApplication_status] = React.useState('');

  //function constants
  const [admin_log, setAdmin_log] = React.useState(false);

  const showModal = () => {
    setOpen(true);
  };

  const showModal2 = () => {
    setOpen2(true);
  };

  const handleOk = () => {
    setModalText('Submitting Values to ROWHWG');
    setApplication_status('Incomplete (Logout)')
    setConfirmLoading(true);
    //dispatch results to ROWHWG website
    postAnnualNetConservation(true);
    postAnnualReportingSummary(true);
    postSummaryOfEffectiveness(true);
    postUpcomingYearForecast(true);
    //console.log('annual_reporting_summary_store', annual_reporting_summary_store)
    //console.log('annual_net_conservation_store', annual_net_conservation_store)
    //console.log('summary_of_effectiveness_store', summary_of_effectiveness_store)
    //console.log('upcoming_year_forecast_store', upcoming_year_forecast_store)
    showModal2();
    setConfirmLoading(true);
    setTimeout(() => {
      sendConfirmationEmail();
      setOpen(false);
      setConfirmLoading(false);
      dispatch(ccaa_actions.reset_ccca_slice());
      navigate('/Login')
    }, 10000);
  };


  const email_message = `
  <html>
  <head>
  <style>
  table, th, td {
    border: 1px solid black;
    border-collapse: collapse;
  }
  th, td {
    padding: 5px;
    text-align: left;
  }
  </style>
  </head>
  <body>

  <p>Thanks for submitting the Annual Reporting Form</p>

  <h2>Organization Name: ${organization_name}</h2>

  <h2>Application Status: ${application_status}</h2>

  <h1>Annual Reporting Form</h1>
  <h2>Annual Reporting Summary</h2>
  <table style="width:100%">
  <tr>
    <th>Acres Enrolled</th>
    <th>Acres Target</th>
    <th>Acres Contributed</th>
    <th>Aditional Explanation</th>
  </tr>
  <tr>
    <td>${annual_reporting_summary_store.acres_enrolled}</td>
    <td>${annual_reporting_summary_store.acres_target}</td>
    <td>${annual_reporting_summary_store.acres_contributed}</td>
    <td>${annual_reporting_summary_store.additional_explanation}</td>
  </tr>
  </table>
  <h2>Annual Net Conservation</h2>
  <table style="width:100%">
  <tr>
    <th>Conservation Measures</th>
    <th>Conservation Measures Implementation</th>
    <th>Partners Overlap</th>
    <th>Supplement Measures</th>
    <th>Additional Supplement Conservation Measures</th>
    <th>Updates to Section 7</th>
  </tr>
  <tr>
    <td>${annual_net_conservation_store.conservation_measures}</td>
    <td>${annual_net_conservation_store.conservation_measures_implementation}</td>
    <td>${annual_net_conservation_store.partners_overlap}</td>
    <td>${annual_net_conservation_store.supplement_measures}</td>
    <td>${annual_net_conservation_store.additional_supplement_conservation_measures}</td>
    <td>${annual_net_conservation_store.updates_to_section_7}</td>
    </tr>
  </table>
  <h2>Summary of Effectiveness</h2>
  <table style="width:100%">
  <tr>
    <th>Methods Effective Monitoring</th>
    <th>Monitoring Results Summary</th>
    <th>Adaptive Management Triggered</th>
    <th>Adaptive Management Actions</th>
    <th>Supplemental Effectiveness Monitoring</th>
  </tr>
  <tr>
    <td>${summary_of_effectiveness_store.methods_effective_monitoring}</td>
    <td>${summary_of_effectiveness_store.monitoring_results_summary}</td>
    <td>${summary_of_effectiveness_store.adaptive_management_triggered}</td>
    <td>${summary_of_effectiveness_store.adaptive_management_actions}</td>
    <td>${summary_of_effectiveness_store.supplemental_effectiveness_monitoring}</td>
    </tr>
  </table>
  <h2>Upcoming Year Forecast</h2>
  <table style="width:100%">
  <tr>
    <th>Anticipate Updates</th>
    <th>General Comments</th>
  </tr>
  <tr>
    <td>${upcoming_year_forecast_store.anticipate_updates}</td>
    <td>${upcoming_year_forecast_store.general_comments}</td>
  </tr>
  </table>
  </body>
  </html>
  `

  const sendConfirmationEmail = async () => {
    try{
      const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/mail_route/v1/mail_route_post', {
        "to": "amaram2@uic.edu",
        "subject":"Submission of Annual Reporting Form (Logout)",
        "message": email_message
      })
    }
    catch(error){
      //console.log(error)
    }
  }


  const handleCancel = () => {
    setOpen(false);
  };
    //API POST FUNCTIONS
    const postAnnualReportingSummary = async (modal_bool) => {
      const bearer_token = sessionStorage.getItem('token');
      try {
         const annual_reporting_post_data =  {
          "organization_name": organization_name,
          "acres_enrolled": annual_reporting_summary_store.acres_enrolled,
          "acres_target": annual_reporting_summary_store.acres_target,
          "acres_contributed": annual_reporting_summary_store.acres_contributed,
          "additional_explanation": annual_reporting_summary_store.additional_explanation
      }
         const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/annual_reporting_route/v1/annual_reporting_post',annual_reporting_post_data,{
          headers: {
            "Authorization": `Bearer ${bearer_token}`
          }
         },);
         if(modal_bool){
          setModalText('Annual Reporting Summary has been submitted');
         }
         return response;
     }
  catch(error){
        return error;
      }
    }

    const postAnnualNetConservation = async (modal_bool) => {
      const bearer_token = sessionStorage.getItem('token');
      try {
          const annual_net_conservation_post_data =  {
            "organization_name": organization_name,
            "conservation_measures": annual_net_conservation_store.conservation_measures.toString(),
            "conservation_measures_implementation": annual_net_conservation_store.conservation_measures_implementation,
            "partners_overlap": annual_net_conservation_store.partners_overlap,
            "supplement_measures": annual_net_conservation_store.supplement_measures.toString(),
            "additional_supplement_conservation_measures": annual_net_conservation_store.additional_supplement_conservation_measures,
            "updates_to_section_7": annual_net_conservation_store.updates_to_section_7.toString()
            }
         const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/annual_net_conservation_route/v1/annual_net_conservation_post',annual_net_conservation_post_data,{
          headers: {
            "Authorization": `Bearer ${bearer_token}`
          }
         },);
          if(modal_bool){
            setModalText("Annual Net Conservation has been submitted");
          }
         return response;
     }
  catch(error){
        return error
      }
    }

    const postSummaryOfEffectiveness = async (modal_bool) => {
      const bearer_token = sessionStorage.getItem('token');
      try {
        const summary_of_effectiveness_post_data =  {
          "organization_name": organization_name,
          "methods_effective_monitoring": summary_of_effectiveness_store.methods_effective_monitoring,
          "monitoring_results_summary": summary_of_effectiveness_store.monitoring_results_summary,
          "adaptive_management_triggered": summary_of_effectiveness_store.adaptive_management_triggered.toString(),
          "adaptive_management_actions": summary_of_effectiveness_store.adaptive_management_actions,
          "supplemental_effectiveness_monitoring": summary_of_effectiveness_store.supplemental_effectiveness_monitoring
        }
         const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/summary_effectiveness_route/v1/summary_effectiveness_post',summary_of_effectiveness_post_data,{
          headers: {
            "Authorization": `Bearer ${bearer_token}`
          }
         },);
        if(modal_bool){
          setModalText("Summary of Effectiveness has been submitted");
        }
         return response;

     }
  catch(error){
        return error
      }
    }


    const postUpcomingYearForecast = async (modal_bool) => {
      const bearer_token = sessionStorage.getItem('token');
      try {
        const upcoming_year_forecast_post_data =  {
          "organization_name": organization_name,
          "anticipate_updates": upcoming_year_forecast_store.anticipate_updates,
          "general_comments": upcoming_year_forecast_store.general_comments
        }
         const response = await axios.post('https://rightofway.erc.uic.edu/wp-json/upcoming_year_forecast_route/v1/upcoming_year_forecast_post',upcoming_year_forecast_post_data,{
          headers: {
            "Authorization": `Bearer ${bearer_token}`
          }
         },);
        if(modal_bool){
          setModalText("Upcoming Year Forecast has been submitted");
        }
         return response;
     }
  catch(error){
        return error
      }
    }


  const handle_logout = () => {
    // sessionStorage.removeItem('token');
    // setReRenderPage(reRenderPage + 1);
    // let props = {
    //   "action": "logout",
    //   "user": sessionStorage.getItem('user_name')
    // }
    //test_monarch(props,MonarchCCAA);
    //navigate('/');

    //check for the form_submitted in the session storage
      showModal();
  }

  //functions to post to db


  useEffect(() => {
    //force rerender the page
    setReRenderPage(reRenderPage + 1);
  }, [logout_store])

  window.BeforeUnloadEvent = function (e) {
    e.preventDefault();
    if(sessionStorage.getItem('form_posted')==='false'){
      showModal();
    }
  };

  useEffect(() => {
    ////console.log('auth_user',auth_user)
    if(auth_user){
      setAdmin_log(true);
    }
    else{
      setAdmin_log(false);
    }
  }, [auth_user])

  const handleAdmin = () => {
    if(sessionStorage.getItem('admin_user_id')){
      navigate('/AdminHome');
    }
    else{
      navigate('/Admin');
    }
  }

  return (
    <div>
    <>
    <Modal
          title="Logout Confirmation"
          visible={open}
          onOk={handleOk}
          confirmLoading={confirmLoading}
          onCancel={handleCancel}
          okText="Save Responses and Logout"
        >
          <div>
            <span>{modalText}</span>
          </div>
    </Modal>
      <div className="nav-menu">
        <div className="nav-menu-logo navbar-brand m-2">
          <img className='project_logo' src={project_logo} alt="ROWHWG Logo"/>
        </div>
        <div className="nav-menu-links">
          <ul>
            {
            <li>
              <a onClick={handleAdmin}>ADMIN</a>
            </li>
            }
            <li>
              <a onClick={handle_logout}>LOGOUT</a>
            </li>
          </ul>
        </div>
      </div>
    </>
    </div>
  )
}

export default Nav